import SectionCard from '../../components/SectionCard.jsx';
import StatusWord, { SeverityWord } from '../../components/StatusWord.jsx';
import { REMOVALS_ID } from './CurrentCampaign.jsx';

// Where a finding row leads (spec 13.1, item 6): the page part that answers it. Rows without a place stay plain text.
const ANCHORS = Object.freeze({ 'ARV-006': `#${REMOVALS_ID}`, 'ARV-007': '#access-reviews-notes' });

/**
 * "Findings between campaigns" (spec 8.2): numbered rows from buildFindings (counts only, the same for every role),
 * severity as a square dot and a word, "Not evaluated" rows kept with their reason.
 */
export default function FindingsCard({ findings, notesShown = false }) {
  return (
    <SectionCard title="Findings between campaigns" description="From every collection, not only during a review" testId="access-reviews-findings">
      {findings.length === 0 ? <p className="text-sm text-ipc-muted">Nothing to report on this collection.</p> : (
        <ol className="space-y-3">
          {findings.map((f, i) => {
            const href = f.id === 'ARV-007' && !notesShown ? null : ANCHORS[f.id];
            return (
              <li key={`${f.id}-${f.roleTemplateId ?? i}`} className="flex gap-3" data-finding={f.id}>
                <span className="w-5 shrink-0 pt-0.5 text-right text-[13px] tabular-nums text-ipc-muted" aria-hidden="true">{i + 1}</span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-ipc-ink">
                    {href && f.evaluated ? <a className="font-semibold text-ipc-light hover:underline" href={href}>{f.sentence}</a> : <span className="font-semibold">{f.sentence}</span>}
                  </p>
                  <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px] text-ipc-muted">
                    {!f.evaluated ? <StatusWord tone="off">Not evaluated</StatusWord>
                      : f.ok === true ? <StatusWord tone="good">Within guidance</StatusWord>
                        : <SeverityWord severity={f.severity} />}
                    <span>{f.evaluated ? f.nextStep : f.reason}</span>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </SectionCard>
  );
}
